import { defineStore } from 'pinia'
import { ref } from 'vue'
import HomeService from '@/services/HomeService'
import type { MenuItem } from '@/types/menu'

function getItemTitle(item: any): string {
  let title = item.title
  if (item.type === 'category') title += `(${item.productCount})`
  return title
}

function getUrl(item: any): string | undefined {
  const baseUrl = import.meta.env.BASE_URL
  if (item.type === 'category') {
    const keyword = (item.keyword as string)?.replace(/\/$/, '')
    let to = keyword
      ? (baseUrl.endsWith('/') ? baseUrl : baseUrl + '/') + keyword
      : (baseUrl.endsWith('/') ? baseUrl : baseUrl + '/') + 'search/?catId=' + item.categoryId
    if (item.target) to += (keyword ? '?' : '&') + item.target
    return to
  }
  if (item.type === 'url') return (item.url as string)?.replace(/\/$/, '') || item.url
}

function buildTree(root: MenuItem, childrenData: any[]) {
  if (!childrenData?.length) return
  root.children = childrenData.map((child: any) => {
    const node: MenuItem = {
      text: getItemTitle(child),
      link: getUrl(child),
      data: child
    }
    buildTree(node, child.children)
    return node
  })
}

export const useMenuStore = defineStore('menu', () => {
  const menu = ref<MenuItem[]>([])
  let fetched = false

  function fetchMenu() {
    if (fetched) return
    fetched = true
    HomeService.menu()
      .then((data: any) => {
        const megaMenu = data?.megaMenuModule
        if (!megaMenu || !Array.isArray(megaMenu)) {
          console.warn('MenuStore: megaMenuModule is not available or not an array')
          fetched = false
          return
        }
        menu.value = megaMenu.map((item: any) => {
          const root: MenuItem = {
            text: getItemTitle(item),
            link: getUrl(item),
            data: item
          }
          buildTree(root, item.children)
          return root
        })
      })
      .catch(() => {
        fetched = false
      })
  }

  return { menu, fetchMenu }
})
